export default "__VITE_ASSET__acEoFIzL__"